const { default: gql } = require('graphql-tag')

export const disableUserAccessMutation = gql`
  mutation DisableUserAccess($userId: ID!) {
    disableUserAccess(userId: $userId) {
      id
    }
  }
`
